import { useState } from 'react';
import SidePanel from '~/components/SidePanel';
import { TrashIcon } from '@heroicons/react/24/outline';
import FileUploadImmediate from '~/components/FileUploadImmediate';

const EditBackgroundImagesPanel = ({ isOpen, onClose, customImages, setCustomImages }) => {
    const [isUploading, setIsUploading] = useState(false);

    const handleMultipleUpload = (urls) => {
        const next = [...(customImages || []), ...(urls || [])].filter(Boolean);
        const unique = Array.from(new Set(next));
        setCustomImages(unique);
    };

    const handleDelete = (index) => {
        const newImages = [...(customImages || [])];
        newImages.splice(index, 1);
        setCustomImages(newImages);
    };

    return (
        <SidePanel title="Gift Certificate Images" isOpen={isOpen} onClose={onClose} showBackArrow={true}>
            <div className="mb-4">
                <p className="text-gray-600 text-sm mb-4">
                    Upload custom background images for your gift certificates.
                </p>

                <FileUploadImmediate
                    accept="image/*"
                    multiple
                    onMultipleChange={handleMultipleUpload}
                    onUploadStateChange={setIsUploading}
                >
                    Upload Images
                </FileUploadImmediate>
            </div>

            {customImages && customImages.length > 0 && (
                <div>
                    <div className="panel-label mb-2">Custom Images</div>
                    <div className="grid grid-cols-2 gap-4">
                        {customImages.map((url, index) => (
                            <div key={index} className="relative group">
                                <img
                                    src={url}
                                    alt={`Custom background ${index + 1}`}
                                    className="rounded-lg max-w-[200px] max-h-[120px]"
                                />
                                <button
                                    type="button"
                                    className="absolute top-2 left-2 bg-red-100 hover:bg-red-200 text-red-600 rounded-full p-2 opacity-0 group-hover:opacity-100 transition-opacity"
                                    onClick={() => handleDelete(index)}
                                    title="Delete image"
                                >
                                    <TrashIcon className="w-4 h-4" />
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {(!customImages || customImages.length === 0) && (
                <div className="text-gray-500 text-center py-8">
                    No custom images uploaded yet, the default images will be used.
                </div>
            )}

            <div className="mt-6">
                <button
                    type="button"
                    className="btn-save"
                    onClick={onClose}
                    disabled={isUploading}
                >
                    Done
                </button>
            </div>
        </SidePanel>
    );
};

export default EditBackgroundImagesPanel;

